module.exports = __webpack_public_path__ + "img/1479098487.5e69ee96.jpg";